import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCharAudioStore = defineStore('charAudio', () => {
  const currentAudioUrl = ref<string | undefined>(undefined)
  const isPlaying = ref<boolean>(false)

  function setCurrentAudioUrl(url: string) {
    currentAudioUrl.value = url
  }

  function setIsPlaying(playing: boolean) {
    isPlaying.value = playing
  }

  function reset() {
    currentAudioUrl.value = undefined
    isPlaying.value = false
  }

  return {
    currentAudioUrl,
    isPlaying,
    setCurrentAudioUrl,
    setIsPlaying,

    reset,
  }
})
